import { React, useEffect, useState } from "react";
import "./my-projects.css";
import "react-responsive-modal/styles.css";
import Breadcrumbs from "../layout/breadcrumb";
import DashCard from "../../compnenets/commons/dash-card";
import Active from "../../assets/Icons/active-users.png";
import OnHold from "../../assets/Icons/onhold.png";
import Canceled from "../../assets/Icons/totalcancel.png";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import Allowcate from "../../assets/Images/allowcate.png";
import Close from "../../assets/Images/close.png";
import User from "../../assets/human.png";
import Location from "../../assets/Images/location.png";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import Filter from "../../assets/Icons/filter.png";
import Download from "../../assets/Icons/download.png";

import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ExcelExport from "../../compnenets/commons/xls";

function MyProjects() {
  const [open, setOpen] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [projectGuid, setProjectGuid] = useState("");
  const [siteEngineer, setSiteEngineer] = useState("");
  const [siteEngineerList, setSiteEngineerList] = useState([]);
  const [isDPRApprovalRequired, setIsDPRApprovalRequired] = useState("Yes");
  const [user, setUser] = useState("");
  const [cardData, setCardData] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const usr = localStorage.getItem("state");
    const state = JSON.parse(usr);

    const allocationData = {
      SiteEngineerID: siteEngineer,
      DPRApprovalRequired: isDPRApprovalRequired,

      ProjectModel: {
        project_id: projectId,
        ProjectGUID: projectGuid,
      },
      UserModel: {
        EmailID: state?.user?.Email,
      },
    };
    const response = await PROJECT_API.projectAllocationToSiteEngineer(
      allocationData
    );
    if (response.IsSuccess === true) {
      getProjects();
      setOpen(false);
      toast.success("Project allocated", { autoClose: 2000 });
    }
  };

  const getSiteEngineers = async () => {
    const se = await PROJECT_API.getSiteEngineers();
    if (se && se.SiteEngineerList?.length) {
      setSiteEngineerList(se.SiteEngineerList);
    }
  };

  const onOpenModal = (e, row) => {
    const state = localStorage.getItem("state");
    let usr = JSON.parse(state);
    setUser(usr?.user);
    if (usr.user?.Role === "Project Manager") {
      if (row?.Project_allocated_to_site_engineer == "Yes") {
        toast.warning("This project is already assigned to site engineer", {
          autoClose: 2000,
        });
      } else {
        setOpen(true);
        setProjectId(row.project_id);
        setProjectGuid(row.ProjectGUID);
        getSiteEngineers();
      }
    } else {
      navigate("/dashboard", { state: row });
    }
  };

  const onCloseModal = () => setOpen(true);
  const onCloseFilter = () => setOpenFilter(true);

  const [projectsData, setProjectsData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const [filterData, setFilterData] = useState({
    dateRange: "",
    projectName: "",
    startDate: "",
    endDate: "",
    projectStatus: "",
    baselineStart: "",
    baselineFinish: "",
    region: "",
    location: "",
    poNo: "",
    projectNumber: "",
    productCategory: "",
    projectManager: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterClick = async () => {
    const projects = await PROJECT_API.getProjectsByFilter(filterData);
    if (projects.status === 200) {
      setProjectsData(projects.project);
    }
    setOpenFilter(false);
  };
  useEffect(() => {
    const state = localStorage.getItem("state");
    let usr = JSON.parse(state);
    setUser(usr?.user);
    getProjects();
    getSiteEngineers();
  }, []);
  const getProjects = async () => {
    const projects = await PROJECT_API.getProjects();
    if (projects.status === 200) {
      const {TotalActive,TotalCanceled,TotalCompleted,TotalOnHold}=projects;
      const obj={
        TotalActive,
        TotalCanceled,
        TotalCompleted,
        TotalOnHold
      }
     setCardData(obj)
      setProjectsData(projects.project);
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(projectsData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = projectsData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      <Modal open={openFilter} onClose={onCloseFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resources">Project Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Date Range</label>
                  <select
                    name="dateRange"
                    value={filterData.dateRange}
                    onChange={handleChange}
                    className="filter-label form-control shadow-none"
                  >
                    <option value="">Select date range</option>
                    <option value="Last1Week">Last 1 Week</option>
                    <option value="Last1Month">Last 1 Month</option>
                    <option value="Last2Months">Last 2 Months</option>
                    <option value="MoreThan3Months">More Than 3 Months</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className="filter-label">Project Name</label>
                  <input
                    type="text"
                    name="projectName"
                    value={filterData.projectName}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Baseline Start</label>
                  <input
                    type="date"
                    name="baselineStart"
                    value={filterData.baselineStart}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Baseline Finish</label>
                  <input
                    type="date"
                    name="baselineFinish"
                    value={filterData.baselineFinish}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Region</label>
                  <input
                    type="text"
                    name="region"
                    value={filterData.region}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Location</label>
                  <input
                    type="text"
                    name="location"
                    value={filterData.location}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">PO No</label>
                  <input
                    type="text"
                    name="poNo"
                    value={filterData.poNo}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Project Number</label>
                  <input
                    type="text"
                    name="projectNumber"
                    value={filterData.projectNumber}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Product Category</label>
                  <input
                    type="text"
                    name="productCategory"
                    value={filterData.productCategory}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Project Manager</label>
                  <input
                    type="text"
                    name="projectManager"
                    value={filterData.projectManager}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Project Status</label>
                  <input
                    type="text"
                    name="projectStatus"
                    value={filterData.projectStatus}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Project</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          {[
            "PO Date",
            "Created Date",
            "Baseline Start",
            "Baseline End",
            "Project Budget",
            "Region",
            "Location",
          ].map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption}
                value={sortOption}
                checked={filterData.sortBy === sortOption}
                onChange={handleChange}
              />
              <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                {sortOption}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => handleFilterClick(filterData)}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="pb-5">
        <Breadcrumbs title="My Projects" menu="" link="My Projects" />
        <div className="row">
          <div className="col-3">
            <DashCard icon={Active} title="Total Active" count={cardData?.TotalActive} />
          </div>
          <div className="col-3">
            <DashCard icon={OnHold} title="Total On Hold" count={cardData?.TotalOnHold} />
          </div>
          <div className="col-3">
            <DashCard icon={Canceled} title="Total Canceled" count={cardData?.TotalCanceled} />
          </div>
          <div className="col-3">
            <DashCard icon={Canceled} title="Total Completed" count={cardData?.TotalCompleted} />
          </div>
        </div>

        <div className="row" style={{ marginTop: 25 }}>
          <div className="d-flex justify-content-end">
            <div className="download-icon">
              <ExcelExport
                data={projectsData?.map((val) => {
                  return {
                    Location: val?.Location,
                    "Project Manager": val?.ProjectOwnerName,
                    "Project Budget": val?.Project_budget,
                    "Baseline Start": val?.baseline_start,
                    "Baseline Finish": val?.baseline_finish,
                    "Project Process": val?.progress,
                    "Project Status": val?.ProjectStatus,
                  };
                })}
                fileName="Project List"
                sheet="Project List"
              />
            </div>
            <div className="filter-icon mx-2 my-auto">
              <img
                className=""
                onClick={() => {
                  setOpenFilter(true);
                }}
                src={Filter}
                width={20}
              />
            </div>
            <div className="my-auto">
              <span
                style={{
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 500,
                  background: "#8add79f7",
                  padding: 5,
                  borderRadius: 12,
                }}
                onClick={() => {
                  getProjects();
                  setCurrentPage(1);
                }}
              >
                Clear filters
              </span>
            </div>
          </div>
        </div>

        <div className="table-container ">
          <table className="custom-table">
            <thead className="table-header">
              <tr>
                <th>Sr No</th>
                <th>Location</th>
                <th>Project Manager</th>
                <th>Project Budget</th>
                <th>Created At</th>
                <th>Baseline Start</th>
                <th>Baseline Finish</th>
                <th>Assigned To</th>
                <th>Project Process</th>
                <th>Project Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td
                    style={{
                      color: "rgb(102 104 106)",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    <img src={Location} width={14} height={18} />
                    &nbsp;
                    {row.Location}
                  </td>
                  <td
                    style={{
                      color: "rgb(102 104 106)",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    <img src={User} width={28} height={28} />
                    &nbsp;
                    {row.Project_Manager}
                  </td>
                  <td
                    style={{
                      color: "rgb(102 104 106)",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {row.Project_budget}
                  </td>
                  <td>{row.Created_dt ? row?.Created_dt : "-"}</td>
                  <td
                    style={{
                      color: "rgb(102 104 106)",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {row.baseline_start}
                  </td>
                  <td
                    style={{
                      color: "rgb(102 104 106)",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {row.baseline_finish}
                  </td>
                  <td>
                    {row?.Project_allocated_to_site_engineer == "Yes" &&
                    user?.Role == "Project Manager" ? (
                      <>
                        {
                          siteEngineerList?.filter(
                            (val) => val?.ID == row?.AssignedToSiteEngineerID
                          )[0]?.Name
                        }
                      </>
                    ) : (
                      <>{user?.Name}</>
                    )}
                  </td>
                  <td>
                    <div
                      className="progress"
                      style={{
                        position: "relative",
                        height: "13px",
                        borderRadius: "40px",
                      }}
                    >
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${row.progress}%`,
                          background:
                            "linear-gradient(90deg, #0FA055 0%, #1B68B4 100%)",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "40px",
                        }}
                        aria-valuenow={row.progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {row.progress}%
                      </div>
                    </div>
                  </td>
                  {/* <td>{row.status}</td> */}

                  <td>
                    <span
                      className={`status-badge ${
                        row.ProjectStatus === "Active"
                          ? "active"
                          : row.ProjectStatus == "On Hold"
                          ? "onHold"
                          : "cancelled"
                      }`}
                    >
                      {row.ProjectStatus}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex justify-center">
                      <button
                        className="action-button"
                        onClick={(e) => onOpenModal(e, row)}
                      >
                        <img src={Allowcate} width={17} height={17} />
                      </button>
                      {user?.Role === "Project Manager" ? (
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: 12,
                            fontWeight: 500,
                            background: "#8add79f7",
                            padding: 5,
                            borderRadius: 12,
                            marginLeft: 5,
                            color: "white",
                          }}
                          onClick={() => {
                            navigate("/project-details", { state: row });
                          }}
                        >
                          View
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div
            className="pagination"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 15px",
            }}
          >
            <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
              Showing{" "}
              {Math.min(
                (currentPage - 1) * rowsPerPage + 1,
                projectsData.length
              )}{" "}
              to {Math.min(currentPage * rowsPerPage, projectsData.length)} of{" "}
              {projectsData.length} entries
            </div>

            <div
              className="pagination-buttons"
              style={{
                fontSize: "14px",
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                gap: "5px",
              }}
            >
              {/* Left Arrow */}
              <button
                onClick={() => handleClick(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                style={{
                  background: "none",
                  border: "none",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src={leftArrow} // Replace with your actual image path
                  alt="Previous"
                  height="11px"
                  width="7px"
                  style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                />
              </button>

              {/* Page Numbers */}
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => handleClick(i + 1)}
                  style={{
                    background:
                      currentPage === i + 1 ? "#00B69B" : "transparent",
                    color: currentPage === i + 1 ? "#fff" : "#000",
                    border: "none",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  {i + 1}
                </button>
              ))}

              {/* Right Arrow */}
              <button
                onClick={() =>
                  handleClick(Math.min(totalPages, currentPage + 1))
                }
                disabled={currentPage === totalPages}
                style={{
                  background: "none",
                  border: "none",
                  cursor:
                    currentPage === totalPages ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src={rightArrow} // Replace with your actual image path
                  alt="Next"
                  height="11px"
                  width="7px"
                  style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
                />
              </button>
            </div>
          </div>
        </div>

        <div id="projectallowcate">
          <Modal open={open} onClose={onCloseModal} center>
            <div className="d-flex justify-content-between">
              <div>
                <span className="allowcate">
                  Project Allocation to Site Engineer
                </span>
              </div>
              <div>
                <img
                  src={Close}
                  width={20}
                  onClick={() => {
                    setOpen(false);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <hr />

            <div className="row mt-3">
              <div className="col-6">
                <label className="label-allowcate">Site Engineer Name</label>
                <select
                  className="filter-label"
                  style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid rgb(197 193 193)",
                    borderRadius: 4,
                  }}
                  value={siteEngineer}
                  onChange={(e) => setSiteEngineer(e.target.value)} // update state
                >
                  <option value="">--Select site engineer--</option>
                  {siteEngineerList?.map((val) => (
                    <option value={val?.ID}>{val?.Name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <label className="label-allowcate">
                  Is DPR Approval Required
                </label>
                <br />
                <div className="form-check form-check-inline mt-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="Yes"
                    checked={isDPRApprovalRequired === "Yes"}
                    onChange={(e) => setIsDPRApprovalRequired(e.target.value)} // update state
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="No"
                    checked={isDPRApprovalRequired === "No"}
                    onChange={(e) => setIsDPRApprovalRequired(e.target.value)} // update state
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    No
                  </label>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="d-flex justify-content-center">
                <div style={{ margin: 10 }}>
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
                <div style={{ margin: 10 }}>
                  <button
                    className="btn btn-danger"
                    onClick={(e) => {
                      setOpen(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default MyProjects;
